import { useState } from "react";
import { useT } from "../i18n";

const WIDTHS = { thumb: 480, medium: 960, large: 1264 };

export const ResponsiveImage = ({ image, sizes, alt, eager = false, className = "", testId, maxVariant = "large" }) => {
  const t = useT();
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-graphite ${className}`} data-testid="image-fallback" role="img" aria-label={alt ?? image.alt ?? ""}>
        <span className="micro-label text-white/40">{t("detail.imageUnavailable")}</span>
      </div>
    );
  }
  const v = image.variants;
  const keys = maxVariant === "thumb" ? ["thumb"] : maxVariant === "medium" ? ["thumb", "medium"] : ["thumb", "medium", "large"];
  return (
    <img
      src={maxVariant === "thumb" ? v.thumb : v.medium}
      srcSet={keys.map((k) => `${v[k]} ${image.widths?.[k] || WIDTHS[k]}w`).join(", ")}
      sizes={sizes}
      alt={alt ?? image.alt ?? ""}
      width={image.width || 1264}
      height={image.height || 848}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : undefined}
      decoding="async"
      onError={() => setFailed(true)}
      className={className}
      data-testid={testId}
    />
  );
};
